import { Component, Input } from '@angular/core';
import { ITourProgress } from '../../interfaces/tour-progress.interface';
import { TourService } from '../../services/tour.service';

@Component({
  standalone: false,
  selector: 'suvo-bi-tour-card',
  templateUrl: './tour-card.component.html',
  styleUrls: ['./tour-card.component.scss'],
})
export class TourCardComponent {
  @Input() currentProgress: ITourProgress = {
    currentIndex: 0,
    totalSteps: 0,
    step: {},
  };

  constructor(private readonly tourService: TourService) {}

  navigatePrevious() {
    this.tourService.previousStep();
  }

  navigateNext() {
    this.tourService.nextStep();
  }

  navigateEnd() {
    this.tourService.endTour();
  }
}
